import { api } from "./client";

export interface IntervalsStatus {
  connected: boolean;
  athlete_id: string | null;
  last_synced_at: string | null;
}

export async function getIntervalsStatus(): Promise<IntervalsStatus> {
  const { data } = await api.get<IntervalsStatus>("/integrations/intervals/status");
  return data;
}

export async function connectIntervals(
  athlete_id: string,
  api_key: string,
): Promise<IntervalsStatus> {
  const { data } = await api.post<IntervalsStatus>("/integrations/intervals", {
    athlete_id,
    api_key,
  });
  return data;
}

export async function disconnectIntervals(): Promise<void> {
  await api.delete("/integrations/intervals");
}

export interface SyncResult {
  new_workouts: number;
  updated: number;
  total: number;
  last_synced_at: string;
}

export async function syncIntervals(days = 30): Promise<SyncResult> {
  const { data } = await api.post<SyncResult>(`/sync/intervals?days=${days}`);
  return data;
}
